/**
 * Created by Astha on 12/3/2018.
 */
import {
  FlexRemoteMoveArgs,
  FlexRemoteMoveQuery,
  FlexZoomCommandResponse,
  RepoItem
} from '../../../autogenerated/ZoomBridge';
import _ from 'lodash';
import HashMap from '../../../protocol/HashMap';
import ThumbnailUtil from '../../../util/ThumbnailUtil';

export class FlexRemoteMove {
  _assetArray: Array<RepoItem>;
  _destFuid: number;
  _metadataMap: HashMap;

  constructor(assetArray: Array<RepoItem>, destFuid: number, metadataMap: HashMap) {
    this._assetArray = assetArray;
    this._destFuid = destFuid;
    this._metadataMap = metadataMap;
  }

  run(): Promise<FlexZoomCommandResponse> {
    const query: FlexRemoteMoveQuery = new FlexRemoteMoveQuery();
    // const remotePaths = this.getInFiles();
    const message: FlexRemoteMoveArgs = new FlexRemoteMoveArgs()
      .setLogMsg('Moving a file')
      .setBid(1)
      .setInFuids(this._assetArray.map((a) => a.getFuid()))
      .setMetadataMap(this._metadataMap)
      .setDestFuid(this._destFuid)
      .setSourceBranch(ThumbnailUtil.HEAD_BRANCH);

    query.message = message;

    return query.run();
  }

  getInFiles() {
    const remotePaths = [];
    _.map(this._assetArray, (asset) => remotePaths.push(asset.getRemotePath()));
    return remotePaths;
  }
}
